import { useQuery, useMutation } from '@tanstack/react-query';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchPersonalData = async (payload = {}) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/personal/datos`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
  );

  if (!response.ok) {
    throw new Error('Error al obtener datos de personal');
  }

  return response.json();
};
